import BarGraphBackground from './BarGraphBackground.vue';
import BarGraphRangeInput from './BarGraphRangeInput.vue';
import BarGraphYAxis from './BarGraphYAxis.vue';
import Vue from 'vue';
export default Vue.extend({
    components: {
        BarGraphBackground,
        BarGraphRangeInput,
        BarGraphYAxis
    },
    props: {
        config: {
            type: Object,
            required: true
        },
        graphDataSummary: {
            type: Object
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        showHints: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            currentColumn: undefined,
            currentHintColumn: undefined,
            currentLabel: undefined,
            previousLabel: undefined,
            rangeInputData: this.config.data.reduce((agg, key) => {
                agg[key.label] = { isCorrect: false, value: 0 };
                return agg;
            }, {})
        };
    },
    methods: {
        handleOnSelectionStart(rangeInputValues) {
            this.currentColumn = rangeInputValues.targetColumn;
            this.currentLabel = rangeInputValues.targetLabel;
            this.previousLabel = rangeInputValues.targetLabel;
            if (this.currentLabel)
                this.rangeInputData[this.currentLabel].value = this.currentColumn;
            if (this.showHints)
                this.setCurrentHintColumn();
            this.$emit('onGraphDataChange', this.rangeInputData);
        },
        handleOnSelectionEnd() {
            this.currentColumn = undefined;
            this.currentLabel = undefined;
        },
        setCurrentHintColumn() {
            this.currentHintColumn = this.config.data.reduce((agg, key) => {
                if (!agg &&
                    key.value !== this.rangeInputData[key.label].value &&
                    key.label === this.previousLabel) {
                    return key.value;
                }
                return agg;
            }, undefined);
        }
    },
    watch: {
        showHints(newShowHintsValue, oldShowHintsValue) {
            if (newShowHintsValue && !oldShowHintsValue) {
                this.setCurrentHintColumn();
            }
        },
        showErrors(newShowErrorsVal, oldShowErrorsVal) {
            if (!newShowErrorsVal && oldShowErrorsVal) {
                this.config.data.forEach(key => {
                    if (this.graphDataSummary[key.label].correctAnswer !==
                        this.graphDataSummary[key.label].currentAnswer) {
                        this.rangeInputData[key.label].value = 0;
                    }
                });
                this.previousLabel = undefined;
            }
            if (newShowErrorsVal && !oldShowErrorsVal) {
                this.config.data.forEach(key => {
                    if (this.graphDataSummary[key.label].correctAnswer ===
                        this.graphDataSummary[key.label].currentAnswer) {
                        this.rangeInputData[key.label].isCorrect = true;
                    }
                });
            }
        }
    }
});
